// @flow
import { useState, useCallback } from 'react';
import { v4 as uuid } from 'uuid';
import omit from 'ramda/es/omit';
import { useTranslation } from 'react-i18next';

import {
  standartRequests,
  type RequestFuncType,
  type StandartRequestFuncType,
} from 'app/common/context/Api';

import { type OrderType } from '../OrderData';
import { type Purchase } from '../../PurchasesApi';


type RequestType = {
  purchases: RequestFuncType,
  [$Values<typeof standartRequests>]: StandartRequestFuncType,
}

/* :: type OrderPreliminary = 0 | 1 | 2; */

const useSubmitOrder = (
  order: OrderType,
  savedOrder: OrderType,
  request: RequestType,
  purchase: Purchase | null,
  handleClose: (void) => void,
) => {
  const { t } = useTranslation('cafeteria');

  // процесс сохранения заказа
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState/* :: <OrderPreliminary> */(0); // 1 - текущий заказ, 2 - предзаказ


  // функция запуска процесса сохранения заказа
  const handleOrderSubmit = useCallback(async (e: SyntheticEvent<HTMLElement>) => {
    e.preventDefault();
    setSending(true);

    // если в режиме редактирования существующего заказа (guid уже существует в orders)
    // то нужно удалить существующий
    if (order && order.guid && purchase && order.guid === purchase.guid) {
      const res = await request.post({
        path: 'cafeteria/customer/purchases',
        rest: { data: { ...savedOrder, status: -1 } },
        cbErrorTextCreate: () => t('order_form_error_change_order', 'Не удалось изменить заказ'),
        id: 'saving',
      });
      if (!res) {
        setSending(false);
        return;
      }
    }

    // делаем новый заказ
    const res = await request.post({
      path: 'cafeteria/customer/purchases',
      rest: { data: { ...omit(['time'], order), guid: uuid() } },
      cbErrorTextCreate: () => t('order_form_error_change_order', 'Не удалось изменить заказ'),
      id: 'saving',
    });

    setSending(false);

    if (res) {
      handleClose();
      setSuccess(order.time ? 2 : 1);
    }
  }, [request, order, purchase, handleClose, savedOrder, t]);


  return [handleOrderSubmit, sending, success];
};

export default useSubmitOrder;
